import React from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import WeatherEventsCard from "./WeatherEventsCard";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PaidIcon from "@mui/icons-material/Paid";
import FlagIcon from "@mui/icons-material/Flag";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import Tooltip from "@mui/material/Tooltip";
import EventsListModal from "./EventsListModal";
import HoursOfOpsButton from "./daily_view/HoursOfOpsButton";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import PersonIcon from "@mui/icons-material/Person";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import DateCardSalesInfo2 from "./DateCardSalesInfo2";
import { get_t_str } from "../../../../helpers/helpers";
import SaveIcon from "@mui/icons-material/Save";
import FolderSpecialIcon from "@mui/icons-material/FolderSpecial";
import SaveAsTemplateButton from "../action_bar_components/save_schedule_buttons/SaveAsTemplateButton";
import LoadFromTemplateButton from "../action_bar_components/load_schedule_buttons/LoadFromTemplateButton";
import CheckIcon from "@mui/icons-material/Check";

export function MenuSection({ children }) {
  return (
    <div className="px-3 pt-2 pb-0.5 text-[11px] font-bold uppercase tracking-[0.08em] text-slate-400">
      {children}
    </div>
  );
}

export function MenuRow({ icon: Icon, label, active, onClick, loading }) {
  return (
    <div
      role="menuitem"
      className={`mx-1 px-2.5 h-9 rounded-md hover:bg-slate-50 cursor-pointer flex items-center gap-3 text-[13px] ${
        active ? "text-violet-700 font-semibold" : "text-slate-700"
      }`}
      onClick={onClick}
    >
      <span className={active ? "text-violet-700" : "text-slate-500"}>
        {loading || <Icon style={{ fontSize: "17px" }} />}
      </span>
      <span className="flex-1 truncate">{label}</span>
      {active && <CheckIcon style={{ fontSize: "16px" }} />}
    </div>
  );
}

function DateCard2(props) {
  const isDropdownOpen = props.openDropdownDate === props.date_str;
  const closeDropdown = () => props.setOpenDropdownDate(null);
  const dtp = props.dailyTemplateProps || {};
  const [saveDailyTemplateOpen, setSaveDailyTemplateOpen] = React.useState(false);
  const [loadDailyTemplateOpen, setLoadDailyTemplateOpen] = React.useState(false);

  const toggleDropdown = (event) => {
    const isMoreVertIconClicked = event.target.classList.contains(
      "more-vert-icon-class"
    );

    if (isMoreVertIconClicked) {
      closeDropdown();
    } else {
      props.setOpenDropdownDate(isDropdownOpen ? null : props.date_str);
    }
  };

  function toggleLocked() {
    props.lock_day(props.d);
  }

  // Ref to the dropdown container
  const dropdownRef = React.useRef(null);

  React.useEffect(() => {
    if (!isDropdownOpen) return;
    const handleClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [isDropdownOpen]);

  // Opening forecast adjusment modal
  const [openForecastAdjustment, setOpenForecastAdjustment] =
    React.useState(false);
  const handleOpenForecastAdjustment = () => setOpenForecastAdjustment(true);
  const handleCloseForecastAdjustment = () => setOpenForecastAdjustment(false);

  // Opening forecast adjusment modal
  const [openHoursOfOps, setOpenHoursOfOps] = React.useState(false);
  const handleOpenHoursOfOps = () => setOpenHoursOfOps(true);
  const handleCloseHoursOfOps = () => setOpenHoursOfOps(false);

  const openNotes =
    props.notesDrawerState?.open &&
    props.notesDrawerState?.dateStr === props.date_str;
  const handleOpenNotes = () => props.openNotesForDate(props.date_str);
  const handleCloseNotes = () => props.closeNotesDrawer();
  const handleSetOpenNotes = (isOpen) =>
    props.setNotesDrawerOpen(isOpen, props.date_str);
  const [flagged, setFlagged] = React.useState(
    props.daily_forecast_exclude_date.length > 0
  );

  // Handle flagging day
  function toggleFlagged() {
    if (flagged) {
      props.deleteForecastExcludeDate(props.date_str);
      setFlagged(false);
    } else {
      const data = {
        date: props.date_str,
        reason: null,
      };
      props.saveForecastExcludeDate(data);
      setFlagged(true);
    }
  }

  const propBlocked = (props.daily_blackout_date?.length ?? 0) > 0;
  const [blocked, setBlocked] = React.useState(propBlocked);

  React.useEffect(() => {
    setBlocked(propBlocked);
  }, [propBlocked, props.date_str]);

  function toggleBlocked() {
    const previous = blocked;
    setBlocked(!previous);
    const request = previous
      ? props.deleteBlackoutDate(props.date_str)
      : props.saveBlackoutDate(props.date_str);
    Promise.resolve(request).catch(() => {
      setBlocked(previous);
    });
  }

  // Opening eventsList modal
  const [openEventsList, setOpenEventsList] = React.useState(false);
  const handleOpenEventsList = () => setOpenEventsList(true);
  const handleCloseEventsList = () => setOpenEventsList(false);

  //const eventsList = [{title: "Golden State Warriors vs Chicago Bulls", description: "NBA game featuring Steph Curry and Zach Lavine. Warriors are 3-2 in this matchup.", distance_away: "10km", impact: "high"}, {title: "SF 49ers vs Miami Dolphins", description: "NFL game with playoff implications. Estimated attendance is 80,000 people.", distance_away: "10km", impact: "high"}]
  const eventsList = props.daily_local_events?.filter(
    (i) => i.distance === null || i.distance <= 15
  );

  const [
    locked,
    date,
    date_str,
    date_dow,
    date_name,
    todays_date_yes,
    dow_name,
    day_shifts,
    day_request_off,
    dow_availability,
    edit_mode,
    day_in_past,
    forecasted_labor_day,
    actual_schedule_labor_day,
    calculated_earned_labor_day,
    actual_used_labor_vs_earned_day,
    adjustment_chosen,
    forecast_sales,
    actual_sales,
    dow_default_operating_hours,
    day_operating_hours,
    day_time_off_requests,
    historical_sales_context,
    day_other_store_shifts,
  ] = props.get_date_info(props.d);

  return (
    <>
      <div
        className={`bg-white h-full`}
      >
        <div className={`${props.windowWidth <= 1023 ? "text-xs" : props.windowWidth <= 1279 ? "text-sm" : "text-base"}`}>
          <div className="rounded flex items-center justify-between min-w-max">
            <h2
              className={`text-[15px] leading-6 font-semibold cursor-pointer ${
                props.todays_date_yes
                  ? "text-violet-700 hover:text-violet-800"
                  : "text-slate-900 hover:text-violet-800"
              }`}
              onClick={() => props.toggleDailyWeekly(props.d)}
            >
              {props.date_name}
            </h2>
            <div className="relative inline-block text-left">
              <div
                className={`more-vert-icon-class w-5 h-6 flex items-center justify-center hover:bg-slate-100 rounded-md cursor-pointer transition-colors duration-150 ${
                  props.todays_date_yes ? "text-violet-700" : "text-slate-400 hover:text-slate-600"
                }`}
                onClick={(event) => {
                  toggleDropdown(event);
                  event.stopPropagation();
                }}
              >
                <MoreVertIcon style={{ fontSize: "18px" }} />
              </div>
            </div>
            {isDropdownOpen && (
              <div
                className="absolute top-5 right-0 mt-2 w-[240px] rounded-xl shadow-xl bg-white border border-slate-200 z-30 py-1"
                ref={dropdownRef}
              >
                <MenuSection>Edit</MenuSection>
                <MenuRow
                  icon={VisibilityIcon}
                  label="View daily schedule"
                  onClick={(event) => {
                    props.toggleDailyWeekly(props.d);
                    toggleDropdown(event);
                  }}
                />
                {!props.day_in_past && (
                  <MenuRow
                    icon={PaidIcon}
                    label="Edit forecasted sales"
                    onClick={(event) => {
                      handleOpenForecastAdjustment();
                      toggleDropdown(event);
                    }}
                  />
                )}
                <MenuRow
                  icon={WatchLaterIcon}
                  label="Adjust hours of operation"
                  onClick={(event) => {
                    handleOpenHoursOfOps();
                    toggleDropdown(event);
                  }}
                />
                <MenuRow
                  icon={NoteAltIcon}
                  label={props.daily_events?.length > 0 ? "Notes" : "Add a note"}
                  onClick={(event) => {
                    handleOpenNotes();
                    toggleDropdown(event);
                  }}
                />

                <MenuSection>Day state</MenuSection>
                {!props.day_in_past && (
                  <MenuRow
                    icon={props.locked ? LockIcon : LockOpenOutlinedIcon}
                    label="Locked for autoschedule"
                    active={props.locked}
                    onClick={(event) => {
                      toggleLocked();
                      toggleDropdown(event);
                    }}
                  />
                )}
                <MenuRow
                  icon={flagged ? FlagIcon : FlagOutlinedIcon}
                  label="Flagged as outlier"
                  active={flagged}
                  onClick={(event) => {
                    toggleFlagged();
                    toggleDropdown(event);
                  }}
                />
                <MenuRow
                  icon={blocked ? EventBusyIcon : EventAvailableIcon}
                  label="Blocked from time off"
                  active={blocked}
                  onClick={(event) => {
                    toggleBlocked();
                    toggleDropdown(event);
                  }}
                />

                {dtp.saveDailyScheduleAsTemplate && (
                  <>
                    <MenuSection>Templates</MenuSection>
                    <MenuRow
                      icon={SaveIcon}
                      label="Save as daily template"
                      onClick={(event) => {
                        setSaveDailyTemplateOpen(true);
                        toggleDropdown(event);
                      }}
                    />
                    {!props.day_in_past &&
                      dtp.dailyTemplateNames?.length > 0 && (
                        <MenuRow
                          icon={FolderSpecialIcon}
                          label="Load from daily template"
                          onClick={(event) => {
                            setLoadDailyTemplateOpen(true);
                            toggleDropdown(event);
                          }}
                        />
                      )}
                  </>
                )}
              </div>
            )}
          </div>
          <button
            type="button"
            data-help-id="schedule-forecasted-sales"
            className="hidden"
            aria-label="Open forecast drawer"
            onClick={handleOpenForecastAdjustment}
          />
          {!props.day_in_past && (
            <button
              type="button"
              data-help-id="schedule-editable-forecasted-sales"
              className="hidden"
              aria-label="Open editable forecast drawer"
              onClick={handleOpenForecastAdjustment}
            />
          )}
          {/* Daily template modals: mounted outside the dropdown so they
              survive the dropdown closing on menu-item click. */}
          {dtp.saveDailyScheduleAsTemplate && (
            <>
              <SaveAsTemplateButton
                hideTrigger
                mode="daily"
                open={saveDailyTemplateOpen}
                onClose={() => setSaveDailyTemplateOpen(false)}
                saveScheduleAsTemplate={(name) =>
                  dtp.saveDailyScheduleAsTemplate(name, props.date_str)
                }
                template_names={dtp.dailyTemplateNames}
                formatDate={dtp.formatDate}
              />
              <LoadFromTemplateButton
                hideTrigger
                mode="daily"
                open={loadDailyTemplateOpen}
                onClose={() => setLoadDailyTemplateOpen(false)}
                week_already_started={props.day_in_past}
                loadFromTemplate={(name, keep) =>
                  dtp.loadDailyFromTemplate(name, keep, props.date_str)
                }
                deleteScheduleTemplate={dtp.deleteDailyScheduleTemplate}
                template_names={dtp.dailyTemplateNames}
                loadFromTemplateFinished={dtp.loadFromTemplateFinished}
                setLoadFromTemplateFinished={dtp.setLoadFromTemplateFinished}
              />
            </>
          )}
        </div>
        {/* {!props.minimizeMode && */}
        <div>
          <DateCardSalesInfo2
            view="weekly"
            forecast_sales={props.forecast_sales}
            actual_sales={props.actual_sales}
            date_name={props.date_name}
            day_of_week_str={props.day_of_week_str}
            edit_mode={props.edit_mode}
            lock_day={props.lock_day}
            locked={props.locked}
            d={props.d}
            day_in_past={props.day_in_past}
            todays_date_yes={props.todays_date_yes}
            adjustment_chosen={props.adjustment_chosen}
            addForecastAdjustment={props.addForecastAdjustment}
            addManualActualSales={props.addManualActualSales}
            addAdjustmentFinished={props.addAdjustmentFinished}
            date_str={props.date_str}
            historical_sales_context={props.historical_sales_context}
            openForecastAdjustment={openForecastAdjustment}
            handleOpenForecastAdjustment={handleOpenForecastAdjustment}
            handleCloseForecastAdjustment={handleCloseForecastAdjustment}
            setOpenForecastAdjustment={setOpenForecastAdjustment}
            minimizeMode={props.minimizeMode}
            isFixed={props.isFixed}
            isHeaderCollapsed={props.isHeaderCollapsed}
            windowWidth={props.windowWidth}
            defaultHours={dow_default_operating_hours?.[0]}
            specialHours={day_operating_hours?.[0]}
            hoo={
              day_operating_hours.length > 0
                ? day_operating_hours[0]
                : dow_default_operating_hours[0]
            }
            daily_intraday_metrics={props.daily_intraday_metrics}
            actual_intraday_metrics={props.actual_intraday_metrics}
            daily_reservation_summary={props.daily_reservation_summary}
            reservation_summary={props.reservation_summary}
            adjustments_history={props.adjustments_history}
            manualSalesInputEnabled={props.manualSalesInputEnabled}
            fetchManualIntradayDistribution={
              props.fetchManualIntradayDistribution
            }
            saveManualIntradayDistribution={
              props.saveManualIntradayDistribution
            }
            eventAttachmentProps={props.eventAttachmentProps}
          />
        </div>
        {/* } */}
        <div className="w-full flex justify-between mt-2">
          <div>
            <WeatherEventsCard
              view="weekly"
              element="weather"
              daily_weather={props.daily_weather}
              daily_events={props.daily_events}
              daily_local_events={props.daily_local_events}
              date_str={props.date_str}
              date_name={props.date_name}
              saveEvent={props.saveEvent}
              updateEvent={props.updateEvent}
              deleteEvent={props.deleteEvent}
              eventAttachmentProps={props.eventAttachmentProps}
              saveEventFinished={props.saveEventFinished}
              setSaveEventFinished={props.setSaveEventFinished}
              openNotes={openNotes}
              handleOpenNotes={handleOpenNotes}
              handleCloseNotes={handleCloseNotes}
              setOpenNotes={handleSetOpenNotes}
              minimizeMode={props.minimizeMode}
              isFixed={props.isFixed}
              isHeaderCollapsed={props.isHeaderCollapsed}
            />
          </div>
          {!props.minimizeMode && !(props.isFixed && props.isHeaderCollapsed) && (
            <div className="flex items-center justify-end gap-x-1">
              {eventsList.length > 0 && (
                <div
                  className="flex items-center text-violet-700 hover:text-violet-900 cursor-pointer"
                  onClick={handleOpenEventsList}
                >
                  <Tooltip
                    title={`There ${eventsList.length === 1 ? "is" : "are"} ${
                      eventsList.length
                    } local ${
                      eventsList.length === 1 ? "event" : "events"
                    } today. Click to see`}
                  >
                    <LocalActivityIcon
                      style={{ fontSize: "14px", marginTop: "1px" }}
                    />
                  </Tooltip>
                </div>
              )}
              {props.locked && (
                <div
                  className="flex items-center text-violet-700 hover:text-violet-900 cursor-pointer"
                  onClick={toggleLocked}
                >
                  <Tooltip title="You have locked this day. This will prevent any changes to this day when any autoscheduler is run. Click to unlock.">
                    <LockIcon
                      style={{ fontSize: "14px" }}
                    />
                  </Tooltip>
                </div>
              )}
              {flagged && (
                <div
                  className="flex items-center text-violet-700 hover:text-violet-900 cursor-pointer"
                  onClick={toggleFlagged}
                >
                  <Tooltip title="You have flagged this day as an outlier. This will prevent this day's sales from being factored into the forecasting algorithm in the future. Click to unflag.">
                    <FlagIcon
                      style={{ fontSize: "14px" }}
                    />
                  </Tooltip>
                </div>
              )}
              {blocked && (
                <div
                  className="flex items-center text-violet-700 hover:text-violet-900 cursor-pointer"
                  onClick={toggleBlocked}
                >
                  <Tooltip title="This date is blocked from time off requests. Click to unblock.">
                    <EventBusyIcon
                      style={{ fontSize: "14px" }}
                    />
                  </Tooltip>
                </div>
              )}
              {props.day_num_employees_working > 0 && (
                <div className="flex items-center text-slate-600">
                  <Tooltip
                    title={`${props.day_num_employees_working} ${
                      props.day_num_employees_working === 1
                        ? "employee"
                        : "employees"
                    } scheduled`}
                  >
                    <div className="flex items-center">
                      <PersonIcon style={{ fontSize: "14px" }} />
                      <p className="text-xs">
                        {props.day_num_employees_working}
                      </p>
                    </div>
                  </Tooltip>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <EventsListModal
        open={openEventsList}
        handleClose={handleCloseEventsList}
        date_str={props.date_str}
        eventsList={eventsList}
      />
      <HoursOfOpsButton
        date_name={date_name}
        hoo={
          day_operating_hours.length > 0
            ? day_operating_hours[0]
            : dow_default_operating_hours[0]
        }
        get_t_str={props.get_t_str}
        dow_name={dow_name}
        edit_hoo={props.edit_hoo}
        // default_checked={day_operating_hours.length > 0 ? false : true}
        default_checked={false}
        start_qhnum={props.start_qhnum}
        open={openHoursOfOps}
        handleClose={handleCloseHoursOfOps}
        view="weekly"
      />
    </>
  );
}

export default DateCard2;
